module.exports = __webpack_public_path__ + "static/img/3102-1.af5ceec6.jpg";